export default {
  liveDataSummary: 'Požiadavky menia živé dáta',
  liveDataDetails: 'Každá požiadavka, ktorú tu odošlete, pracuje so živými dátami s vašimi oprávneniami. Zmeny a odstránenia platia okamžite a nedajú sa vrátiť späť.',
};
